module.exports = __webpack_public_path__ + "static/media/Flask_icon.75f93e02.png";